export default "__VITE_ASSET__BjQbVwjX__"